import { render } from "./AllAlertsSection.vue?vue&type=template&id=198371da"
import script from "./AllAlertsSection.vue?vue&type=script&lang=js"
export * from "./AllAlertsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__